import React, { useState } from 'react'
import { Card, Col, Row } from "react-bootstrap"
import { IconButton } from '@fluentui/react/lib/Button';

import PartyBodyCardLE from './PartyBodyCardLE';
import { useTranslation } from "react-i18next";
import SidePanelUsers from './SidePanelUsers';
import { ActionButton } from '@fluentui/react/lib/Button';
import { deletePartyById } from "../../../../services/sBook/party.service";
import '../../../../styles/css/PartyCard.css'
import PartyBodyCardBU from './PartyBodyCardBU';
import { isNullUndefined } from '../../../../common/Helpers';

function PartyCard(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_BookId = props.bookId;
    const inputParam_BookObject = props.bookObject;
    const inputParam_PartyItem = props.partyItem;
    const inputParam_SetterDeleteParty = props.setterDeleteParty;
    const inputParam_RoleList = props.roleList;
    
    const inputParam_SelectedCard = props.selectedCard;
    const inputParam_SetterSelectedCard = props.setterSelectedCard;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ?  props.editMode : false;

    const inputParam_SetterMessage = props.setterMessage !== null && props.setterMessage !== undefined ?  props.setterMessage : null;
    const inputParam_SetterSuccessful = props.setterSuccessful !== null && props.setterSuccessful !== undefined ?  props.setterSuccessful : null;
    const inputParam_SetterShowMessage = props.setterShowMessage !== null && props.setterShowMessage !== undefined ?  props.setterShowMessage : false;
    const inputParam_SetterMessageType = props.setterMessageType !== null && props.setterMessageType !== undefined ?  props.setterMessageType : null;
    const inputParam_SetBookPartyList = props.setBookPartyList !== null && props.setBookPartyList !== undefined ?  props.setBookPartyList : null;
    
    const inputParam_NookPartyList = props.bookPartyList !== null && props.bookPartyList !== undefined ?  props.bookPartyList : null;
    const inputParam_RelatedConceptHasPartys = props.relatedConceptHasPartys !== null && props.relatedConceptHasPartys !== undefined ?  props.relatedConceptHasPartys : false;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;

    const [isPanelOpen, setIsPanelOpen] = useState(false);

    const onSelectPartyUsers = () => {
        setIsPanelOpen(true);
    }

    const onDeleteParty = () => {
        if (inputParam_PartyItem.id !== 0) {
            deletePartyById(inputParam_PartyItem.id).then((response) => {

                if (response.data.succeeded) {
                    inputParam_SetterDeleteParty && inputParam_SetterDeleteParty(inputParam_PartyItem);
                    inputParam_SetterMessage(t('data-lang-msg-operationperformed'));
                    inputParam_SetterSuccessful(true);
                    inputParam_SetterShowMessage(true);
                    inputParam_SetterMessageType("success");
                }
                else {
                    inputParam_SetterMessage(t('data-lang-msg-operationerror'));
                    inputParam_SetterSuccessful(false);
                    inputParam_SetterShowMessage(true);
                    inputParam_SetterMessageType("error");
                }
            }).catch(() => {
                inputParam_SetterDeleteParty && inputParam_SetterDeleteParty(inputParam_PartyItem);
            });   
        }
        else {
            inputParam_SetterDeleteParty && inputParam_SetterDeleteParty(inputParam_PartyItem);
            inputParam_SetterMessage(t('data-lang-msg-operationperformed'));
            inputParam_SetterSuccessful(true);
            inputParam_SetterShowMessage(true);
            inputParam_SetterMessageType("success");
        }
    }

    const updatePartySectionUserCount = (partyId, userCount) => {
        
        inputParam_NookPartyList.data.data.forEach(element => {
            if (element.id === partyId) {
                element.userCounts = userCount;
            }
        });


        inputParam_SetBookPartyList && inputParam_SetBookPartyList(prevState => ({
            ...prevState,
            data: inputParam_NookPartyList.data
        }));
        
    }

    const onSelectCardClick = () => {
        inputParam_SetterSelectedCard(inputParam_PartyItem);
    }

    return (
        <Card className={`${inputParam_SelectedCard ? (inputParam_SelectedCard.id === inputParam_PartyItem.id ? "selected-card" : "") : ""}`}>
            <Card.Body className="card-party p-1">
                {
                    inputParam_EditMode && inputParam_UserHasConfigRoleAction && inputParam_BookObject.mainBook === true &&
                    <>
                        {
                            (inputParam_RelatedConceptHasPartys === true && (inputParam_PartyItem.manager === null && inputParam_PartyItem.counterParty === null)) && 
                            <div style={{cursor: "pointer", position: "absolute", right: "0px"}}>
                                <IconButton iconProps={{ iconName: 'ChromeClose' }} title={t('data-lang-btn-delete')} onClick={ onDeleteParty } />
                            </div>
                        }
                        {
                            (inputParam_RelatedConceptHasPartys === false) && 
                            <div style={{cursor: "pointer", position: "absolute", right: "0px"}}>
                                <IconButton iconProps={{ iconName: 'ChromeClose' }} title={t('data-lang-btn-delete')} onClick={ onDeleteParty } />
                            </div>
                        }
                    </>
                }
                {
                    inputParam_EditMode && inputParam_UserHasConfigRoleAction && inputParam_BookObject.mainBook === false &&
                    <div style={{cursor: "pointer", position: "absolute", right: "0px"}}>
                        <IconButton iconProps={{ iconName: 'ChromeClose' }} title={t('data-lang-btn-delete')} onClick={ onDeleteParty } />
                    </div>
                }
                <div className='d-flex' style={{cursor: inputParam_PartyItem.id !== 0 ? "pointer" : "default"}} onClick={ inputParam_PartyItem.id !== 0 ? onSelectCardClick : null }>
                    {
                        (inputParam_PartyItem.legalEntityId === null) ?
                        <PartyBodyCardBU partyItem={inputParam_PartyItem} /> : <></>
                    }
                    {
                        (inputParam_PartyItem.businessUnitId === null) ?
                        <PartyBodyCardLE partyItem={inputParam_PartyItem} /> : <></>
                    }
                </div>
            </Card.Body>
            <Card.Footer className='p-0'>
                <Row>
                    {
                        (!isNullUndefined(inputParam_PartyItem.counterParty) || !isNullUndefined(inputParam_PartyItem.manager)) &&
                        <Col className="col-auto me-auto my-auto ms-1"><div>{t(inputParam_PartyItem.manager ? 'data-lang-lbl-mandante' : (inputParam_PartyItem.counterParty ? 'data-lang-lbl-contratista' : ''))}</div></Col>
                    }
                    <Col className="col-auto ms-auto">
                        {
                            inputParam_EditMode && inputParam_UserHasConfigRoleAction && inputParam_PartyItem.id !== 0 &&
                            <ActionButton className="float-end" styles={{root: {maxHeight: "30px"}}} onClick={ () => onSelectPartyUsers() } iconProps={{ iconName: 'PeopleAdd' }} allowDisabledFocus disabled={false} checked={false}>
                                {`${ t('data-lang-btn-selectusers') } (${ inputParam_PartyItem.userCounts })`}
                            </ActionButton>
                        }
                        {
                            !inputParam_EditMode && inputParam_PartyItem.id !== 0 &&
                            <ActionButton className="float-end" styles={{root: {maxHeight: "30px"}}} onClick={ () => onSelectPartyUsers() } iconProps={{ iconName: 'PeopleAdd' }} allowDisabledFocus disabled={false} checked={false}>
                                {`${ t('data-lang-btn-viewusers') } (${ inputParam_PartyItem.userCounts })`}
                            </ActionButton>
                        }
                    </Col>
                </Row>            
            </Card.Footer>
            <SidePanelUsers
                bookId={ inputParam_BookId }
                partyId={ inputParam_PartyItem.id }
                partyType={ inputParam_PartyItem.type }
                isPanelOpen={ isPanelOpen }
                setterIsPanelOpen={ setIsPanelOpen }
                roleList={ inputParam_RoleList }
                editMode={ inputParam_EditMode }
                userHasConfigRoleAction={inputParam_UserHasConfigRoleAction}
                leId={ inputParam_PartyItem.legalEntityId !== null ? inputParam_PartyItem.legalEntityId : null }
                buId={ inputParam_PartyItem.businessUnitId !== null ? inputParam_PartyItem.businessUnitId : null }
                setterUpdateUserCount={ updatePartySectionUserCount }
            />
        </Card>
    );
}

export default PartyCard;